import type { IconData } from '@stacksjs/iconify-core'

export const pin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M531 99q45 46 68 103t23 117t-23 117t-68 103L327 743q-7 7-16 7t-16-7L91 539q-45-45-68-103T0 319t23-117T91.5 99T194 31T311 8t117 23t103 68M383 391q15-15 22-34t7-38t-7-38t-22-34t-34-22t-38-7t-38 7t-34 22t-22 34t-8 38t8 38t22 34t34 22t38 8t38-8t34-22\"/>",
  "width": 630,
  "height": 850,
  "viewBox": "0 0 630 850"
}

export default pin
